import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import confetiAnimation from '../../assets/confetti.json';
import LottieAnimation from '../../hooks/getLottie';

function Producto({ titulo, estado, descripcion, imagenUrl }) {
  const sanitizedHTML = DOMPurify.sanitize(descripcion || '');
  const plainDescription = sanitizedHTML.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  const shortDescription = plainDescription.length > 90
    ? `${plainDescription.slice(0, 90).trimEnd()}...`
    : plainDescription;

  return (
    <Link
      to={`/producto/${titulo}`}
      className={`group relative mb-4 flex h-full w-full flex-col overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-[0_10px_24px_-18px_rgba(15,39,75,0.6)] transition-all duration-300 hover:-translate-y-0.5 hover:border-[#00BEE7]/60 hover:shadow-[0_20px_32px_-20px_rgba(0,190,231,0.55)] ${
        estado === 'Agotado' ? 'cursor-not-allowed opacity-70' : 'cursor-pointer'
      }`}
    >
      <div className="relative h-40 md:h-52 overflow-hidden bg-gradient-to-b from-slate-50 to-white p-3 md:p-4">
        <img
          src={imagenUrl}
          className="h-full w-full object-contain transition-transform duration-300 group-hover:scale-[1.04]"
          alt={titulo}
          onError={(e) => { e.currentTarget.src = 'https://dps2wxsijib8x.cloudfront.net/atst/LOGO-ATST.png'; e.currentTarget.onerror = null; }}
        />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-14 bg-gradient-to-t from-slate-200/40 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        {estado === 'Agotado' && (
          <div className="absolute top-2 right-2 z-10 bg-gray-500 text-white text-[10px] font-bold uppercase px-2 py-0.5 rounded-full">
            Agotado
          </div>
        )}
      </div>
      {estado === 'Proximamente' && (
        <>
          <div className="absolute top-2 right-0 z-10 bg-emerald-100 border-l border-t border-b border-emerald-300 rounded-l px-3 py-0.5">
            <h3 className="uppercase text-emerald-600 font-bold text-xs">
              {estado}
            </h3>
          </div>
          <div className="absolute inset-0 w-full h-full z-0">
            <LottieAnimation animationData={confetiAnimation} />
          </div>
        </>
      )}
      <div
        className={`relative z-10 flex flex-1 flex-col justify-between gap-2 border-t border-slate-100 px-3 py-3 ${
          estado === 'Agotado'
            ? 'bg-gray-100'
            : 'bg-[#0f274b] group-hover:bg-[#0e355f] transition-colors duration-300'
        }`}
      >
        <h5 className={`text-sm md:text-base font-extrabold uppercase leading-tight ${
          estado === 'Agotado' ? 'text-gray-500' : 'text-white'
        }`}>{titulo}</h5>
        <p
          className={`text-[11px] md:text-xs leading-snug ${
            estado === 'Agotado' ? 'text-gray-500' : 'text-blue-100/95'
          }`}
          style={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {shortDescription || 'Consulta disponibilidad y especificaciones técnicas.'}
        </p>
        <span className={`inline-flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide ${
          estado === 'Agotado' ? 'text-gray-500' : 'text-[#00d0f3]'
        }`}
        >
          Ver ficha
          <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </span>
      </div>
    </Link>
  );
}

Producto.propTypes = {
  titulo: PropTypes.string.isRequired,
  estado: PropTypes.string.isRequired,
  descripcion: PropTypes.string.isRequired,
  imagenUrl: PropTypes.string.isRequired,
};

export default Producto;
